// extracted by mini-css-extract-plugin
export default {"banner":"CubClub_banner__ExPTf","buttonDis":"CubClub_buttonDis__Ne77o","cubIcon":"CubClub_cubIcon__UQZkL","cubTitle":"CubClub_cubTitle__aCQNF","learnDis":"CubClub_learnDis__D0+mj"};